import React from 'react';
import '../component/footer.css';
import facebook from '../images/f.png';
import linkedin from '../images/li.png';
import logo from '../images/ecell.PNG';
import twitter from '../images/tw.png';
import instaram from '../images/i.png';

function Footer() {
  return (
    <div className='mainFooterDiv'>
        <div className='logoDiv'>
            <a href="#" ><img className='logoEcell' src={logo} alt="" /></a>
            <p>Ecell, JEC Jabalpur</p>
        </div>
        <div>
          @2022 @all rights reserved
        </div>
        <div className='socialMedia'>
        <a href="" target="_blank"><img className='iconsFooter' src={facebook} alt="" id="logo"/></a>
        {/* <img className='iconsFooter' src={facebook}/> */}
        <a href="https://www.instagram.com/ecell_jec/" target="_blank"><img className='iconsFooter' src={instaram} alt="" id="logo"/></a>
        {/* <img className='iconsFooter' src={instaram}/> */}
        <a href="" target="_blank"><img className='iconsFooter' src={twitter} alt="" id="logo"/></a>
        {/* <img className='iconsFooter' src={twitter}/> */}
        <a href="https://www.linkedin.com/company/e-cell-jec/?viewAsMember=true" target="_blank" ><img className='iconsFooter' src={linkedin} alt="" id="logo"/></a>
        {/* <img className='iconsFooter' src={linkedin}/> */}
        </div>
    </div>
  )
}

export default Footer